import React from "react";
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby";
import { Col, Row } from "react-bootstrap";

const FeatureOne = (props) => {
    let data = props.data;
    return (
        <section className="what-we-do sec-pad service-page">
            <div className="thm-container">
                <div className="sec-title text-center">
                    <span>{data.subtitle}</span>
                    <h3>{data.title}</h3>
                    <p>{data.content}</p>
                </div>
                <Row>
                    <Col lg={6}>
                        <div className="single-what-we-do">
                            <div className="img-box">
                                <GatsbyImage
                                    alt={data.benefits[0].image.altText}
                                    loading={"lazy"}
                                    image={data.benefits[0].image.imageFile.childImageSharp.gatsbyImageData}
                                    formats={["auto", "webp", "avif"]}
                                />
                            </div>
                            <div className="text-box hvr-bounce-to-bottom">
                                <Link to={data.benefits[0].url}>
                                    <h3>{data.benefits[0].title}</h3>
                                </Link>
                                <p>{data.benefits[0].content}</p>
                                <Link
                                    to={data.benefits[0].url}
                                    className="read-more fas fa-angle-right"
                                ></Link>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        {data.benefits
                            .slice(1, data.benefits.length)
                            .map((benefit, index) => (
                                <div className="single-what-we-do-two clearfix" key={index}>
                                    <div className="img-box">
                                        <GatsbyImage
                                            alt={benefit.image.altText}
                                            loading={"lazy"}
                                            image={benefit.image.imageFile.childImageSharp.gatsbyImageData}
                                            formats={["auto", "webp", "avif"]}
                                            style={{maxWidth: "210px"}}
                                        />
                                    </div>
                                    <div className="text-box">
                                        <h3>
                                            {benefit.title}
                                        </h3>
                                        <p>{benefit.content}</p>
                                    </div>
                                </div>
                            ))}
                    </Col>
                </Row>
            </div>
        </section>
    );
};

export default FeatureOne;
